document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.product-description');
  if (!container) return;

  // Prevent double-initialization (in case the script runs more than once)
  if (container.dataset.tabsInitialized === 'true') {
    return;
  }
  container.dataset.tabsInitialized = 'true';

  const children = Array.from(container.children);
  const sections = [];
  const preContentNodes = []; // Content before the first TAB- marker
  let currentSection = null;
  let startedSections = false;

  children.forEach(node => {
    const text = (node.textContent || '').trim();

    // Detect markers like TAB-Title, TAB-Key-Features, TAB-Support-&-Resources, etc.
    // Supports letters, numbers, spaces, hyphens and ampersands.
    const match = text.match(/^TAB-([A-Za-z0-9\- &]+)/);

    if (match) {
      startedSections = true;

      // Close previous section if it exists
      if (currentSection) {
        sections.push(currentSection);
      }

      const rawTitle = match[1].trim();
      const title = rawTitle.replace(/-/g, ' ');

      // Remove the marker node from the DOM (we don't want to display "TAB-...")
      node.remove();

      currentSection = {
        title: title,
        nodes: []
      };
    } else if (!startedSections) {
      // Content before the first TAB marker -> keep it as-is
      preContentNodes.push(node);
    } else if (currentSection) {
      // Add nodes to the current section
      currentSection.nodes.push(node);
    }
  });

  // Push last section
  if (currentSection) {
    sections.push(currentSection);
  }

  // If there are no TAB markers, do nothing
  if (!sections.length) return;

  const hasPreContent = preContentNodes.length > 0;

  // Clear the container
  container.innerHTML = '';

  // Re-append content that was before the first TAB marker
  preContentNodes.forEach(node => container.appendChild(node));

  // Build accordion DOM structure
  sections.forEach((section) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'tab-accordion';
    wrapper.dataset.tabName = section.title.toLowerCase();

    const header = document.createElement('button');
    header.type = 'button';
    header.className = 'tab-accordion__header';
    header.textContent = section.title;

    const panel = document.createElement('div');
    panel.className = 'tab-accordion__panel';

    // Move original nodes into the panel
    section.nodes.forEach(n => panel.appendChild(n));

    wrapper.appendChild(header);
    wrapper.appendChild(panel);
    container.appendChild(wrapper);
  });

  // Second pass: set initial state + attach listeners
  const accordions = Array.from(container.querySelectorAll('.tab-accordion'));
  const ANIMATION_DURATION = 350; // ms - should roughly match CSS transition

  // Handle "Find Authorized Distributor" links that point to #shop anchor
  // The anchor now lives inside a tab panel, so we open the tab and scroll to it
  document.querySelectorAll('a[href="#shop"]').forEach(link => {
    link.addEventListener('click', function (event) {
      const targetAccordion = accordions.find(w => w.dataset.tabName === 'distributors');
      if (!targetAccordion) return;

      event.preventDefault();

      const targetHeader = targetAccordion.querySelector('.tab-accordion__header');
      const targetPanel = targetAccordion.querySelector('.tab-accordion__panel');
      const alreadyOpen = targetAccordion.classList.contains('is-open');

      if (!alreadyOpen) {
        accordions.forEach(otherWrapper => {
          if (otherWrapper === targetAccordion) return;
          const otherHeader = otherWrapper.querySelector('.tab-accordion__header');
          const otherPanel = otherWrapper.querySelector('.tab-accordion__panel');
          if (!otherHeader || !otherPanel) return;
          otherWrapper.classList.remove('is-open');
          otherHeader.setAttribute('aria-expanded', 'false');
          otherPanel.style.maxHeight = '0px';
        });

        targetAccordion.classList.add('is-open');
        targetHeader.setAttribute('aria-expanded', 'true');
        targetPanel.style.maxHeight = targetPanel.scrollHeight + 'px';
      }

      const SCROLL_OFFSET = window.innerWidth < 768 ? 180 : 160;
      setTimeout(() => {
        const top = targetAccordion.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });
      }, alreadyOpen ? 0 : ANIMATION_DURATION);
    });
  });

  accordions.forEach((wrapper, index) => {
    const header = wrapper.querySelector('.tab-accordion__header');
    const panel = wrapper.querySelector('.tab-accordion__panel');
    if (!header || !panel) return;

    const shouldOpenByDefault = !hasPreContent && index === 0;

    // Initial state
    if (shouldOpenByDefault) {
      wrapper.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      wrapper.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0px';
    }

    header.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      // Guard: ignore clicks while this accordion is animating
      if (wrapper.dataset.animating === 'true') {
        return;
      }
      wrapper.dataset.animating = 'true';

      const isOpen = wrapper.classList.contains('is-open');

      if (isOpen) {
        // Close current
        wrapper.classList.remove('is-open');
        header.setAttribute('aria-expanded', 'false');
        panel.style.maxHeight = '0px';
      } else {
        // Close all others first (accordion behavior)
        accordions.forEach(otherWrapper => {
          if (otherWrapper === wrapper) return;

          const otherHeader = otherWrapper.querySelector('.tab-accordion__header');
          const otherPanel = otherWrapper.querySelector('.tab-accordion__panel');
          if (!otherHeader || !otherPanel) return;

          otherWrapper.classList.remove('is-open');
          otherHeader.setAttribute('aria-expanded', 'false');
          otherPanel.style.maxHeight = '0px';
        });

        // Open current
        wrapper.classList.add('is-open');
        header.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      // Release the lock after the transition finishes
      setTimeout(() => {
        wrapper.dataset.animating = 'false';
      }, ANIMATION_DURATION);
    });
  });
});